import { cn } from '@/shared/lib/utils';
import type { ReactNode } from 'react';

interface LabeledValueProps {
  /** Body 14/M · tertiary */
  label: string;
  /** Body 16/SB · 기본 primary. 색은 className 으로 */
  children: ReactNode;
  className?: string;
  valueClassName?: string;
}

/** 카드 안의 "라벨 / 값" 2단 묶음 (거래 병의원 · 7월 등록 처방 · 등록 파일 …) */
export function LabeledValue({
  label,
  children,
  className,
  valueClassName,
}: LabeledValueProps) {
  return (
    <div className={cn('flex min-w-0 flex-1 flex-col items-start', className)}>
      <span className="text-body-14 font-medium whitespace-nowrap text-fg-tertiary">
        {label}
      </span>
      <div
        className={cn(
          'text-body-16 font-semibold whitespace-nowrap text-fg-primary',
          valueClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
}
